//@flow

import type { ReportType, CommitmentType } from "../../constants/types";

import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { ArticleActions } from "../../redux/articles";
import { CountsActions } from "../../redux/counts";

import CreatedCommitments from "./CreatedCommitments";
import { withRouter } from "react-router-dom";

export const StatsContainer = styled.div`
  display: flex;
  align-items: stretch;
  max-width: 1167px;
  margin: auto;
  justify-content: center;
  padding: ${props => (props.extraPadding ? "52px 0 25px 0" : "25px 0")};
  @media (max-width: 996px) {
    align-items: space-around;
    padding: 10px 0;
    flex-direction: column;
  }
`;

class CommitmentStatisticsContainer extends Component<
  {
    report: ReportType,
    reportIndex?: number,
    expanded?: boolean,
    graphHistory?: {
      [string]: {
        values: Array<number>,
        labels: Array<string>,
        texts: Array<string>
      }
    },
    commitment: ?CommitmentType,
    meterChartTypeList?: { [string]: string }
  },
  {
    expanded: boolean
  }
> {
  state = {
    expanded: this.props.expanded || false
  };

  componentWillMount() {
    this.props.getCommitmentCounts();
    this.props.getDoneLifestyleTestCount();
    this.props.getAverageReduction();
    this.props.getTopLifestyleCommitments();
  }

  render() {
    return (
      <Fragment>
        <CreatedCommitments
          commitmentCounts={this.props.commitmentCounts}
          lifeStyleTestCount={this.props.doneLifestyleTestCount}
        />
        {/*                  
        <LifestyleCommitmentStatisticsContainer
          averageReduction={this.props.averageReduction}
          topLifestyleCommitments={this.props.topLifestyleCommitments}
        /> 
        */}
      </Fragment>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      commitmentCounts: state.articles.commitmentCountForAllTypes,
      doneLifestyleTestCount: state.counts.doneLifestyleTestCount,
      averageReduction: state.counts.averageReduction,
      topLifestyleCommitments: state.counts.topLifestyleCommitments
    }),
    {
      getCommitmentCounts: ArticleActions.getCommitmentCountForAllTypes,
      getDoneLifestyleTestCount: CountsActions.getDoneLifestyleTestCount,
      getAverageReduction: CountsActions.getAverageReduction,
      getTopLifestyleCommitments: CountsActions.getTopLifestyleCommitments
    }
  )(CommitmentStatisticsContainer)
);



// WEBPACK FOOTER //
// ./src/components/statistics/CommitmentStatisticsContainer.js